import { SortingState } from '@tanstack/react-table';
import { ExpectedQueryData } from 'components/table/hooks/useServerFilteredTable';
import { PromoCode, PromoCodeStatus } from 'models/PromoCode';
import {
  FetchPromoCodesSortBy,
  fetchPromoCodes,
} from 'components/domain/promoCode/useFetchPromoCodes';
import { getSortParam } from 'components/table/utils/sorting';
import { getPaginationParams } from 'components/table/utils/pagination';

export const PROMO_CODES_BASE_QUERY_KEY = 'promo-codes';

export const promoCodesQuery = ({
  pageIndex,
  pageSize,
  sorting,
  status,
}: {
  pageIndex: number;
  pageSize: number;
  sorting: SortingState;
  status: PromoCodeStatus;
}) => {
  const sort = getSortParam<FetchPromoCodesSortBy>(sorting, {
    code: FetchPromoCodesSortBy.SORT_BY_CODE,
    value: FetchPromoCodesSortBy.SORT_BY_VALUE,
    expirationUTCDateTime: FetchPromoCodesSortBy.SORT_BY_EXPIRATION_DATE_TIME,
    validFromUTCDateTime: FetchPromoCodesSortBy.SORT_BY_VALID_FROM_DATE_TIME,
    propertyUid: FetchPromoCodesSortBy.SORT_BY_STATUS,
    singleUsage: FetchPromoCodesSortBy.SORT_BY_SINGLE_USAGE,
  });

  return {
    queryKey: [PROMO_CODES_BASE_QUERY_KEY, { pageIndex, sorting }, status],
    queryFn: async (): Promise<ExpectedQueryData<PromoCode>> => {
      const response = await fetchPromoCodes({
        statuses: [status],
        ...(sort ? { sort: sort.sort, sortDirection: sort.direction } : {}),
        ...getPaginationParams({ pageIndex, pageSize }),
      });

      const { promoCodes, _metadata } = response;

      return {
        data: promoCodes,
        _metadata,
      };
    },
    enabled: true,
  };
};
